import { AllocationFragment } from 'generated/resources/graphql'

export const sumAllocationsAmountCents = (allocations: AllocationFragment[]) => {
  return allocations.reduce((acc, allocation) => acc + Number(allocation?.amountCents), 0)
}

export const allocationsOverBudget = (
  budgetLimit: number,
  limitPerEmployeeCents: number,
  numberOfEmployees: number,
  totalAllocatedAmountCents: number
) => {
  const budgetLimitNum = Number(budgetLimit)
  const totalAllocatedNum = Number(totalAllocatedAmountCents)

  const total = limitPerEmployeeCents * numberOfEmployees + totalAllocatedNum
  const isOver = budgetLimitNum < total

  return isOver
}

export const allocationsWithAmountIds = (allocations: AllocationFragment[]) => {
  return allocations
    .filter((allocation) => allocation.amountCents !== null)
    .map((allocation) => allocation.id)
}
